var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "editor-toolbar" }, [
    _c("div", { staticClass: "toolbar-btn-group" }, [
      _c("label", { staticClass: "toolbar-btn toolbar-add-img clickable" }, [
        _c("input", {
          ref: "imageInputRef",
          staticClass: "no-display",
          attrs: { type: "file", accept: _vm.acceptableImageTypeString },
          on: { click: _vm.resetImageInput, change: _vm.onImageChange }
        })
      ]),
      _vm._v(" "),
      _c("button", {
        staticClass: "toolbar-btn toolbar-add-video clickable",
        on: { click: _vm.addVideo }
      }),
      _vm._v(" "),
      _c("label", { staticClass: "toolbar-btn toolbar-add-audio clickable" }, [
        _c("input", {
          staticClass: "no-display",
          attrs: { type: "file", accept: _vm.acceptableAudioTypeString },
          on: { change: _vm.onAudioChange }
        })
      ]),
      _vm._v(" "),
      _c("button", {
        staticClass: "toolbar-btn toolbar-add-math clickable",
        on: { click: _vm.addMath }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "toolbar-btn-group" }, [
      _c("button", {
        staticClass: "toolbar-btn toolbar-bold-text clickable",
        on: { click: _vm.boldText }
      }),
      _vm._v(" "),
      _c("button", {
        staticClass: "toolbar-btn toolbar-italic-text clickable",
        on: { click: _vm.italicText }
      }),
      _vm._v(" "),
      _c("button", {
        staticClass: "toolbar-btn toolbar-underline-text clickable",
        on: { click: _vm.underlineText }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "toolbar-btn-group" }, [
      _c("button", {
        staticClass: "toolbar-btn toolbar-add-ul clickable",
        on: { click: _vm.addUl }
      }),
      _vm._v(" "),
      _c("button", {
        staticClass: "toolbar-btn toolbar-add-ol clickable",
        on: { click: _vm.addOl }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6b57aa4e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b57aa4e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditorToolbar.vue
// module id = t1lr
// module chunks = 1